import { render, staticRenderFns } from "./text-content.vue?vue&type=template&id=1aba8976"
import script from "./text-content.vue?vue&type=script&lang=js"
export * from "./text-content.vue?vue&type=script&lang=js"
import style0 from "./text-content.vue?vue&type=style&index=0&id=1aba8976&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports